export const fleetCategories = [
  {
    id: "small-cars",
    path: "/car-rental/small-cars",
    label: "Small Cars",
    eyebrow: "SMALL CAR HIRE PERTH",
    title: "Small Car Rental in Perth",
    resultsTitle: "Affordable Small Cars for Hire in Perth",
    linkLabel: "View Small Car Rentals",
    summary: "Affordable small car hire in Perth for city travel, business appointments, local travel and easier parking.",
    description:
      "Small car rental in Perth is a practical and affordable choice for city driving, business appointments, local trips and everyday travel. Compact cars such as the Suzuki Swift are easy to drive, economical and convenient for parking around Perth CBD and surrounding suburbs.",
    secondaryDescription:
      "TAK8 Car Rental offers daily car rental, weekly car hire and long-term small car hire from our convenient East Perth location. Compare current prices, availability, seating, luggage capacity and kilometre options before selecting your vehicle.",
    benefits: [
      "Suitable for city driving and local trips",
      "Compact size for easier parking",
      "Clear limited and unlimited kilometre options",
    ],
    faqs: [
      {
        question: "What small car availble for hire in perht?",
        answer:
          "TAK8 Car Rental currently offers compact vehicles such as the Suzuki Swift. Available models may vary depending on your selected dates.",
      },
      {
        question: "How much does small car rental cost in Perth?",
        answer:
          "Small car rental rates depend on the rental period, kilometre allowance and vehicle availability. Enter your pick-up and return dates to view current prices.",
      },
      {
        question: "Are small rental cars suitable for driving around Perth?",
        answer:
          "Yes. Compact car rental are well suited to Perth CBD, local appointments, everyday travel and areas where easier parking is helpful.",
      },
      {
        question: "Can I hire a small car for a week or longer?",
        answer:
          "Yes. TAK8 offers daily rental, weekly rental and long-term small car hire, subject to availability and the applicable rental terms.",
      },
      {
        question: "Where can I collect my compact car rental?",
        answer:
          "Vehicle collection is available from TAK8 Car Rental at 17 Regal Place, East Perth, close to Perth CBD.",
      },
    ],
    aliases: ["small", "compact", "economy", "hatchback"],
    fallbackTerms: ["swift", "hatchback", "compact", "small car"],
  },
  {
    id: "sedans",
    path: "/car-rental/sedans",
    label: "Sedans",
    eyebrow: "SEDAN CAR RENTAL PERTH",
    title: "Sedan Car Rental in Perth",
    resultsTitle: "Affordable Sedan Cars for Hire in Perth",
    linkLabel: "View Sedan Rentals",
    summary: "Affordable Sedan car hire in Perth for city travel, business appointments, local travel and easier parking.",
    description:
      "Sedan rental cars offer a useful balance of passenger comfort and luggage space for travelling around Perth. They can suit everyday transport, business appointments and longer road journeys.",
    secondaryDescription:
      "Compare the sedans available from TAK8 Car Rental by transmission, seating, luggage capacity, rental rate and kilometre allowance.",
    benefits: [
      "Comfortable seating for everyday travel",
      "Practical luggage space for longer journeys",
      "Suitable for business and leisure trips",
    ],
    faqs: [
      {
        question: "Which vehicles appear under sedan car rental?",
        answer:
          "The sedan category shows vehicles identified as sedans in the current TAK8 Car Rental fleet. Available models may change according to fleet status and your selected dates.",
      },
      {
        question: "Is a sedan suitable for a longer drive from Perth?",
        answer:
          "Sedans can suit longer journeys when their seating and luggage capacity meet your needs. Review each vehicle card and the applicable rental conditions before selecting it.",
      },
      {
        question: "Can I compare sedan kilometre options?",
        answer:
          "Yes. Where available, each vehicle card displays both the daily kilometre allowance and the unlimited kilometre rate so you can compare them before booking.",
      },
    ],
    aliases: ["sedan", "family car", "family"],
    fallbackTerms: ["corolla", "camry", "commodore", "sedan"],
  },
  {
    id: "suvs",
    path: "/car-rental/suvs",
    label: "SUVs",
    eyebrow: "SUV RENTAL PERTH",
    title: "SUV Rental in Perth",
    resultsTitle: "Affordable SUV and 7-Seater Hire in Perth",
    linkLabel: "View SUV and 7 Seater Rentals",
    summary: "More passenger and luggage room for families, groups and longer journeys.",
    description:
      "SUV rental can provide additional passenger space and flexible luggage capacity for trips around Perth and Western Australia. The available fleet may include compact SUVs and larger seven-seat vehicles.",
    secondaryDescription:
      "Check each TAK8 Car Rental SUV for its seating capacity, luggage space, current availability, daily price and kilometre options before booking.",
    benefits: [
      "Compact and larger SUV options",
      "Useful passenger and luggage capacity",
      "Options for family trips and longer travel",
    ],
    faqs: [
      {
        question: "What types of SUVs can I hire in Perth?",
        answer:
          "The category may include compact SUVs and larger seven-seat SUVs from the active TAK8 Car Rental fleet. The vehicles displayed are based on current fleet data.",
      },
      {
        question: "Are seven-seat SUVs shown in this category?",
        answer:
          "Yes. A seven-seat vehicle will appear here when it is classified as an SUV and remains part of the current fleet. Confirm its exact seating and luggage capacity on the vehicle card.",
      },
      {
        question: "How can I check whether an SUV is available?",
        answer:
          "Select your rental dates in the booking form. The website will show the availability status and applicable prices for each SUV returned by the booking system.",
      },
    ],
    aliases: ["suv", "7 seater", "7-seater", "crossover"],
    fallbackTerms: [
      "outlander",
      "cx3",
      "cx-3",
      "cx8",
      "cx-8",
      "suv",
      "crossover",
      "7 seater",
      "7-seater",
    ],
  },
  {
    id: "people-movers",
    path: "/car-rental/people-movers",
    label: "People Movers",
    eyebrow: "PEOPLE MOVER HIRE PERTH",
    title: "People Mover Hire in Perth",
    resultsTitle: "Affordable 8-Seater and People Mover Hire in Perth",
    linkLabel: "View 8-Seater Rentals",
    summary: "Spacious vehicles for families and groups travelling together.",
    description:
      "People mover hire is designed for customers who need more passenger capacity in one vehicle. It can be a practical option for family travel, group outings and journeys with additional luggage.",
    secondaryDescription:
      "Review the people movers in the TAK8 Car Rental fleet and confirm the number of seats, luggage capacity, rates and availability for your chosen dates.",
    benefits: [
      "Higher passenger capacity for group travel",
      "Practical option for families travelling together",
      "Vehicle-specific seating and luggage details",
    ],
    faqs: [
      {
        question: "How many passengers can a people mover carry?",
        answer:
          "Capacity depends on the individual vehicle. Check the seats and bags displayed on the vehicle card and make sure the selected vehicle suits every passenger and their luggage.",
      },
      {
        question: "Can I hire a people mover for a family trip?",
        answer:
          "Yes, subject to availability and the rental conditions. People movers can be useful when a family or group wants to travel together in one vehicle.",
      },
      {
        question: "Are people mover prices shown online?",
        answer:
          "The website displays the current rates returned for each people mover. Enter your rental dates to check availability and the prices that apply to your booking period.",
      },
    ],
    aliases: ["people mover", "people-mover", "minivan", "van", "minibus"],
    fallbackTerms: [
      "carnival",
      "people mover",
      "people-mover",
      "minivan",
      "minibus",
      "8 seater",
      "8-seater",
      "12 seater",
      "12-seater",
    ],
  },
  {
    id: "utes",
    path: "/car-rental/utes",
    label: "Utes",
    eyebrow: "UTE HIRE PERTH",
    title: "Ute Hire in Perth",
    resultsTitle: "Affordable Ute Hire in Perth",
    linkLabel: "View Ute Rentals",
    summary: "Utility vehicles for customers who need passenger seating and carrying space.",
    description:
      "Ute hire can suit customers who need a practical utility vehicle together with passenger seating. Always review the specific vehicle details and rental conditions to confirm it is appropriate for your intended use.",
    secondaryDescription:
      "Browse the utes currently listed by TAK8 Car Rental and compare seating, carrying capacity, kilometre options, rates and availability.",
    benefits: [
      "Passenger seating with additional carrying space",
      "Vehicle details shown before selection",
      "Limited and unlimited kilometre rates where available",
    ],
    faqs: [
      {
        question: "Which vehicles are included in the ute category?",
        answer:
          "This category displays utility and pickup-style vehicles identified in the current TAK8 Car Rental fleet. Available models may change as the fleet is updated.",
      },
      {
        question: "Can a rental ute be used for any type of work?",
        answer:
          "Permitted use depends on the vehicle and the rental agreement. Review the complete rental terms or contact TAK8 Car Rental before booking if you have a specific use in mind.",
      },
      {
        question: "How do I check ute hire availability?",
        answer:
          "Enter your pickup and return dates to see the availability and rates returned for the utes currently in the fleet.",
      },
    ],
    aliases: ["ute", "utility", "pickup", "pick-up", "pickup truck"],
    fallbackTerms: ["hilux", "ute", "utility", "pickup", "pick-up"],
  },
];

const normaliseCategoryValue = (value) => {
  if (!value) return "";
  if (typeof value === "object") {
    return String(value.name || value.label || value.slug || "").toLowerCase();
  }
  return String(value).toLowerCase();
};

const includesAny = (text, terms) => terms.some((term) => text.includes(term));

export const getVehicleCategoryId = (car = {}) => {
  const explicitCategory = [
    car.category,
    car.vehicleCategory,
    car.bodyType,
    car.carType,
    car.vehicleType,
    car.classification,
  ]
    .map(normaliseCategoryValue)
    .filter(Boolean)
    .join(" ");

  if (explicitCategory) {
    const explicitMatch = fleetCategories.find((category) =>
      includesAny(explicitCategory, category.aliases)
    );
    if (explicitMatch) return explicitMatch.id;
  }

  const vehicleText = [
    car.name,
    car.brand,
    car.model,
    car.description,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  const fallbackOrder = [
    "people-movers",
    "utes",
    "suvs",
    "sedans",
    "small-cars",
  ];

  for (const categoryId of fallbackOrder) {
    const category = fleetCategories.find((item) => item.id === categoryId);
    if (category && includesAny(vehicleText, category.fallbackTerms)) {
      return category.id;
    }
  }

  if (Number(car.seats) >= 7) return "suvs";
  if (Number(car.bags) <= 2 && Number(car.seats) <= 5) return "small-cars";
  return "sedans";
};

export const getCarsForFleetCategory = (cars = [], categoryId) =>
  cars.filter((car) => getVehicleCategoryId(car) === categoryId);

export const getAvailableFleetCategories = (cars = []) =>
  fleetCategories
    .map((category) => {
      const categoryCars = getCarsForFleetCategory(cars, category.id);
      const prices = categoryCars
        .map((car) => Number(car.defaultRatePerDay))
        .filter((price) => Number.isFinite(price) && price > 0);

      return {
        ...category,
        vehicleCount: categoryCars.length,
        representativeCar: categoryCars[0] || null,
        fromPrice: prices.length ? Math.min(...prices) : null,
      };
    })
    .filter((category) => category.vehicleCount > 0);

export const getFleetCategory = (categoryId) =>
  fleetCategories.find((category) => category.id === categoryId) ||
  fleetCategories[0];
